import {getPrivateAxios, TeamSubscription} from '@blesk-frontend/api';

export const fetchBillingSubscription = async () => {
  const {data} = await getPrivateAxios().get<TeamSubscription | null>('/billing/subscription');
  return data || null;
};
